/**
 * Copyright (c) 2021 BlockDev AG
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import Web3 from 'web3';
import { AffiliateSnapshot, CampaignDataResponse, State } from '../components/models';
import { abi } from '../abi';
import http from '../http/http';

let _web3: Web3 | undefined = undefined;

export const getWeb3 = async () => {
    if (_web3) {
        return _web3;
    }

    try {
        await (window as any).ethereum.request({ method: 'eth_requestAccounts' });
        _web3 = new Web3((window as any).ethereum);
        return _web3;
    } catch (err) {
        throw new Error('You need to allow metamask');
    }
};

export const claimAllowed = (data: CampaignDataResponse, claimed: string): boolean => {
    const { total } = data.snapshot;
    return parseInt(total) > parseInt(claimed);
};

export const loadState = async (): Promise<State> => {
    const web3 = await getWeb3();

    const getClaimed = async (wallet: string, rewarderAddress: string): Promise<string> => {
        if (!web3) {
            throw new Error('web3 undefined');
        }
        const r = new web3!.eth.Contract(abi, rewarderAddress);
        const account = web3.utils.toChecksumAddress(wallet);
        const result = await r.methods.totalPayoutsFor(account).call({ from: wallet });
        return String(result);
    };

    const coinbase = await web3!.eth.getCoinbase();
    const userWallet = coinbase.toLowerCase();
    const state: State = { wallet: userWallet };
    const resp = await http.get<CampaignDataResponse>('/affiliate-rewards/' + state.wallet);

    if (resp && resp.data) {
        state.data = resp.data;
        state.claimed = await getClaimed(String(state.wallet), state.data.rewarderAddress);
    }

    return state;
};

export const claim = async (
    rewarderAddress: string,
    wallet: string,
    snapshot: AffiliateSnapshot
): Promise<any> => {
    const web3 = await getWeb3();
    if (!web3) throw new Error('web3 undefined');

    const account = web3.utils.toChecksumAddress(wallet);
    const proof = snapshot.proofs.map(item => {
        item = '0x' + item;
        return item;
    });

    // const abi = require('./abi');
    const r = new web3!.eth.Contract(abi, rewarderAddress);
    const c = r.methods.claim(account, snapshot.total, snapshot.blockNumber, proof);
    return await c.send({
        from: wallet,
    });
};
